(function () {
  if (window.__cfInteractionsInit) return;
  window.__cfInteractionsInit = true;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var style = document.createElement('style');
  style.textContent =
    '[data-cf-reveal]:not(.is-visible){opacity:0;transform:translateY(24px);transition:opacity 700ms cubic-bezier(.16,1,.3,1),transform 700ms cubic-bezier(.16,1,.3,1);transition-delay:calc(var(--cf-reveal-index,0) * 70ms)}' +
    '[data-cf-reveal].is-visible{opacity:1;transform:translateY(0)}' +
    '@media (prefers-reduced-motion: reduce){[data-cf-reveal]{opacity:1!important;transform:none!important;transition:none!important}}' +
    '[data-cf-carousel]{scroll-behavior:smooth}' +
    '@media (prefers-reduced-motion: reduce){[data-cf-carousel]{scroll-behavior:auto}}' +
    '.cf-carousel-nav{display:flex;align-items:center;justify-content:center;gap:16px;margin-top:20px}' +
    '.cf-carousel-dots{display:flex;align-items:center;gap:6px}' +
    '.cf-carousel-dot{width:6px;height:6px;border-radius:999px;background:currentColor;opacity:.28;border:none;padding:0;cursor:pointer;transition:opacity 200ms ease,width 200ms ease}' +
    '.cf-carousel-dot.is-active{opacity:1;width:18px}' +
    '.cf-carousel-arrow{width:34px;height:34px;flex:0 0 auto;border-radius:999px;border:1px solid currentColor;opacity:.45;background:transparent;display:inline-flex;align-items:center;justify-content:center;cursor:pointer;transition:opacity 150ms ease;color:inherit}' +
    '.cf-carousel-arrow:hover{opacity:.9}' +
    '.cf-carousel-arrow:disabled{opacity:.12;cursor:default}' +
    '.cf-carousel-arrow svg{width:15px;height:15px}' +
    '@media (min-width:768px){.cf-carousel-nav{display:none}}';
  document.head.appendChild(style);

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('[data-cf-reveal]');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );
    revealEls.forEach(function (el, i) {
      el.style.setProperty('--cf-reveal-index', i % 6);
      revealObserver.observe(el);
    });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Animated counters (numbers / percentages) ---------- */
  var counters = document.querySelectorAll('[data-cf-counter]');
  if (counters.length && 'IntersectionObserver' in window) {
    var counterObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          counterObserver.unobserve(entry.target);
          var el = entry.target;
          var raw = el.getAttribute('data-cf-counter');
          var target = parseFloat(raw);
          var decimals = (raw.split('.')[1] || '').length;
          var suffix = el.getAttribute('data-cf-counter-suffix') || '';
          if (prefersReducedMotion) {
            el.textContent = target.toFixed(decimals) + suffix;
            return;
          }
          var duration = 1400;
          var start = null;
          function step(ts) {
            if (!start) start = ts;
            var progress = Math.min((ts - start) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            el.textContent = (target * eased).toFixed(decimals) + suffix;
            if (progress < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        });
      },
      { threshold: 0.4 }
    );
    counters.forEach(function (el) { counterObserver.observe(el); });
  }

  /* ---------- Animated fill bars ---------- */
  var bars = document.querySelectorAll('[data-cf-bar-fill]');
  if (bars.length && 'IntersectionObserver' in window) {
    var barObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          barObserver.unobserve(entry.target);
          var el = entry.target;
          var target = el.getAttribute('data-cf-bar-fill');
          if (prefersReducedMotion) {
            el.style.transition = 'none';
            el.style.width = target + '%';
          } else {
            requestAnimationFrame(function () {
              el.style.width = target + '%';
            });
          }
        });
      },
      { threshold: 0.3 }
    );
    bars.forEach(function (el) {
      el.style.width = '0%';
      barObserver.observe(el);
    });
  }

  /* ---------- Carousel dot/arrow controls (mobile scroll-snap tracks) ---------- */
  document.querySelectorAll('[data-cf-carousel]').forEach(function (track) {
    var items = Array.prototype.slice.call(track.children);
    if (items.length < 2) return;

    var nav = document.createElement('div');
    nav.className = 'cf-carousel-nav';

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'cf-carousel-arrow';
    prevBtn.setAttribute('aria-label', 'Previous');
    prevBtn.innerHTML =
      '<svg viewBox="0 0 20 20" fill="none"><path d="M12.5 15 7.5 10l5-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'cf-carousel-dots';
    var dots = items.map(function (item, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'cf-carousel-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Go to item ' + (i + 1));
      dot.addEventListener('click', function () { scrollToItem(i); });
      dotsWrap.appendChild(dot);
      return dot;
    });

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'cf-carousel-arrow';
    nextBtn.setAttribute('aria-label', 'Next');
    nextBtn.innerHTML =
      '<svg viewBox="0 0 20 20" fill="none"><path d="M7.5 15l5-5-5-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    nav.appendChild(prevBtn);
    nav.appendChild(dotsWrap);
    nav.appendChild(nextBtn);
    track.insertAdjacentElement('afterend', nav);

    function animateScrollTo(target) {
      /* Relies on the CSS `scroll-behavior: smooth` set on [data-cf-carousel] above — the browser's
         own scroll implementation animates and interrupts/retargets in-flight scrolls natively, so
         there's no custom requestAnimationFrame loop here to race against itself on rapid clicks
         (an rAF-based version of this function failed twice in real-world use — see refinement-log.md
         Round 06/08 — because rAF is also unreliable in backgrounded/low-priority tab states). */
      track.scrollLeft = target;
    }

    function scrollToItem(i) {
      var item = items[i];
      animateScrollTo(item.offsetLeft - track.offsetLeft);
    }

    var currentIndex = 0;
    function updateActive() {
      var trackRect = track.getBoundingClientRect();
      var center = trackRect.left + trackRect.width / 2;
      var closest = 0;
      var closestDist = Infinity;
      items.forEach(function (item, i) {
        var r = item.getBoundingClientRect();
        var itemCenter = r.left + r.width / 2;
        var dist = Math.abs(itemCenter - center);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      if (closest !== currentIndex) {
        dots[currentIndex].classList.remove('is-active');
        dots[closest].classList.add('is-active');
        currentIndex = closest;
      }
      prevBtn.disabled = track.scrollLeft <= 4;
      nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    }

    prevBtn.addEventListener('click', function () {
      updateActive(); /* resync currentIndex from the real scroll position — a debounced
        scroll-driven currentIndex can lag behind rapid clicks, causing the next click to
        target a position it's already at (silently no-op'd by animateScrollTo's < 1px guard). */
      scrollToItem(Math.max(0, currentIndex - 1));
    });
    nextBtn.addEventListener('click', function () {
      updateActive();
      scrollToItem(Math.min(items.length - 1, currentIndex + 1));
    });

    var scrollTimer;
    track.addEventListener(
      'scroll',
      function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(updateActive, 60);
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateActive, 100);
    });

    updateActive();
  });
  });
})();
